import { cache as defaultCache } from "apollo/client";
import { initialEditState } from "state/defaults";
import isEqual from "lodash.isequal";
import pick from "lodash.pick";
import gql from "graphql-tag";

const dirtyStateQuery = gql`
  query @client {
    initialEditState {
      ruleName
      frequency
      filters
      notificationRecipient
    }
    dirtyState {
      ruleName
      frequency
      filters
      notificationRecipient
    }
  }
`;

const keys = Object.keys(initialEditState);

const isDirty = (cache = defaultCache) => {
  const { initialEditState, dirtyState } = cache.readQuery({
    query: dirtyStateQuery,
  });

  return !isEqual(pick(initialEditState, keys), pick(dirtyState, keys));
};

export default isDirty;



// WEBPACK FOOTER //
// ./src/utils/isDirty.js